const errorsHu = {
    "unable_to_create_event": "Nem sikerült létrehozni az eseményt. Hibakód: {{error_code}}",
    "event_delete_error": "Nem sikerült törölni az eseményt. Hibakód: {{error_code}}",
    "guest_info_update_error": "Nem sikerült frissíteni a vendég adatait. Hibakód: {{error_code}}",
    "schedule_item_overlap": "Az asztal a kiválasztott időpontban már foglalt",
    "move_to_room": "Terembe nem lehet helyezni foglalást. Válasszon helyette egy asztalt!",
    "move_to_occupied_table": "Ez az asztal már foglalt ebben az időpontban. A foglalt asztalra húzás le van tiltva.",
    "mail_error": "Nem sikerült elküldeni az e-mailt. Hibakód: {{error_code}}",
    "unable_to_update_reservation": "Nem sikerült frissíteni a foglalást. Hibakód: {{error_code}}",
    "sms_error": "Nem sikerült elküldeni az SMS-t. Hibakód: {{error_code}}",
    "date_range_max": "A dátumtartomány nem lehet hosszabb, mint {{days}} nap",
    "outstanding_invoice_alert": "Tájékoztatjuk, hogy jelenleg {{count}} lejárt számlája van. Kérjük, hogy mielőbb rendezze fennálló tartozását. Felhívjuk figyelmét, hogy amennyiben a tartozás meghaladja a 30 napot, szolgáltatásunk szüneteltetésre kerülhet.",
    "no_access_to_page": "Nincs hozzáférése ehhez az oldalhoz.",
    "no_access_helper": "Ha úgy gondolja, hogy ez hiba, kérjük lépjen kapcsolatba az étterem adminisztrátorával.",
    "image_upload_error": "Nem sikerült feltölteni a képet. Hibakód: {{error_code}}",
    "max_character_length": "Maximum hossz: {{max_length}} karakter",
}

export default errorsHu;